

















































import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

export default Vue.extend({
  name: 'Login',
  components: { VariableInput },
  data() {
    return {
      accountData: new models.CAuth(),
      saveUserData: true,
      items: [
        {key: 'mail', name: 'メールアドレス', type: vi.INPUT_TYPE.TEXT, placeholder: 'sample@rimolabo.com', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', max: 40, class: 'text_40' },
        {key: 'password', name: 'パスワード', type: vi.INPUT_TYPE.PASSWORD, placeholder: '半角大小英数字を1文字ずつ含む8文字以上', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
      ] as vi.IVariableInput[],
      horses: [
        {subTitle: 'クライアントツールをインストール', subTitleImg: 'images/login/icon01pc.svg', mainImg: 'images/login/01_clienttool.PNG', detail: 'リモラボへ登録が完了したら、従業員のPCへクライアントツールのダウンロードとインストールを行います。\nトップバー右のアイコンからアカウント画面へ移動し「クライアントツールのダウンロード」から、最新のバージョンをダウンロードしてください。', fixed: '1'},
        {subTitle: '労務管理者と従業員の登録', subTitleImg: 'images/login/icon09pc.svg', mainImg: 'images/login/02_mentenance.png', detail: 'ユーザー管理画面より、労務管理者と従業員を新規に登録しましょう。\nまた、所定労働時間や勤怠の締め日、休日などの設定を行い、就業形態を新規追加・変更も可能です。', fixed: '2'},
        {subTitle: 'サンプルグラフでの確認', subTitleImg: 'images/login/icon02pc.svg', mainImg: 'images/login/03_newgraph.png', detail: '登録した情報とクライアントツールから取得したログとをもとに、グラフを生成します。', fixed: '3'},
        {subTitle: 'グラフの作成・就業形態の追加', subTitleImg: 'images/login/icon06pc.svg', mainImg: 'images/login/04_samplegraph.png', detail: 'サンプルグラフをダッシュボードで確認できます。\n従業員それぞれの就業形態の追加やグラフの作成など、自由にカスタマイズできます。', fixed: 'Ex'},
      ],
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  created() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
    }
    if (localStorage.userEmail) {
      this.$data.accountData.mail = localStorage.userEmail;
    }
  },
  async mounted() {
    document.getElementsByClassName('carousel-control-next')[0].removeAttribute('href');
    document.getElementsByClassName('carousel-control-prev')[0].removeAttribute('href');
    await this.$router.push('/Login', () => {});
  },
  methods: {
    onClickLogin() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      if (this.$data.saveUserData) {
        localStorage.userEmail = this.$data.accountData.mail;
      }
      this.$emit('login', this.accountData);
    },
  },
});
